import { j as m } from "./atoms-v218.js";
import { Label as p } from "./atoms-v222.js";
const $ = ({
  children: e,
  className: s,
  colorTheme: a = "light",
  hasValue: o = !1,
  htmlFor: t = "",
  isDisabled: i = !1,
  isFocused: l = !1,
  variant: r = "productive"
}) => /* @__PURE__ */ m.jsx(
  p,
  {
    $colorTheme: a,
    $hasValue: o,
    $isDisabled: i,
    $isFocused: l,
    $variant: r,
    className: s,
    htmlFor: t,
    children: e
  }
);
export {
  $ as InputLabel
};
